import { FragmentNames, ScoreFlexCreateAliases } from '../../../../codegen/index';
import BaseController from '../../../BaseController';
import Controller, { OnBeforeCancel, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { ScoreType } from '../../scores-references/score-reference-controller';
import { ScoreListContext } from '../../scores-list/scores-list-service';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { LocatorTypes } from '../../../locator/locator-controller';
import timeService from '../../../../services/time-service';
import { ISO_FULL_DATE_FORMAT } from '../../../../constants/date-utils';
import moment from 'moment';
import { AutocompleteAPI, FetchAPI, InputAPI, LocatorAPI, LocatorFieldAPI, MapperAPI } from '@philips-internal/oswald-ui-components';
import { Inject} from '@odinjs/odin';
import { Endpoint } from '../../../../constants/endpoints';
import { HealthProfessionalUser } from 'src/app/authentication';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { AbortableCloseEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { EventData } from '@philips-internal/oswald-ui-core/lib/component/event';
import DialogService from '../../../../services/dialog-service';

@Controller({ component: ScoreFlexCreateAliases.SCORE_FLEX_ADD_LAYOUT, fragment: FragmentNames.SCORE_FLEX_CREATE })
export default class ScorePewsCreateController extends BaseController {

  @Inject(ScoreFlexCreateAliases.INPUT_SETUP_DATE)
  private setupDateInputApi!: InputAPI;

  @Inject(ScoreFlexCreateAliases.LOCATOR_FIELD_PROFESSIONAL)
  private locatorFieldApi!: LocatorFieldAPI;

  @Inject(ScoreFlexCreateAliases.FETCH_PROFESSIONAL)
  private fetchProfessionalApi!: FetchAPI;

  @OnMount({ target: ScoreFlexCreateAliases.SCORE_FLEX_ADD_LAYOUT })
  handleFormMount(): void {
    ScoreListContext.currentTab = ScoreType.SCORE_FLEX
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    InformationBarUtils.collapsedBar = true;
    this.context.set({ encounterId, locator: LocatorTypes.PROFESSIONAL_PERSON, patientId });
    timeService.getCurrentDateTime()
      .then(date => this.setupDateInputApi.setValue(date))
      .catch(() => this.setupDateInputApi.setValue(moment().format(ISO_FULL_DATE_FORMAT)))
  }

  @OnMount({ target: ScoreFlexCreateAliases.FIELD_PROFESSIONAL })
  handleMountProfessional(): void {
    const user = foundationContext.getUser() as unknown as HealthProfessionalUser;
    this.locatorFieldApi.setValue(user?.physicalPersonId)
    this.fetchProfessionalApi.setEndpoint(Endpoint.GET_PROFESSIONAL_PERSON);
  }

  @OnMount({ target: ScoreFlexCreateAliases.LOCATOR_PROFESSIONAL })
  handleMountProfessionalLocator(event: MountEvent): void {
    const locatorApi = event.target as unknown as LocatorAPI;
    const user = foundationContext.getUser() as unknown as HealthProfessionalUser;
    locatorApi.setValue({
      personCode: user?.physicalPersonId,
      personName: user?.name,
    })
  }

  @OnMount(ScoreFlexCreateAliases.AUTOCOMPLETE_SCORE_FLEX)
  handleAutocompleteScoreFlexOnMount({ target }: EventData<AutocompleteAPI>): void {
    target.setEntry('descScore');
    target.setPrimaryKey('descScore');
  }

  @OnMount(ScoreFlexCreateAliases.MAPPER_SCORE_FLEX)
  handleOnMountScoreFlexMapper({ target }: EventData<MapperAPI>): void {
    target.setMap({ value: 'descScore' });
  }

  @OnBeforeCancel({ target: ScoreFlexCreateAliases.FORM_SCORE_FLEX_ADD })
  onCancelForm(event: AbortableCloseEvent): void {
    event.abort();
    this.discardChanges();
  }

  private discardChanges(): void {
    DialogService.open({
      descriptionDialog: 'clinical-notes.discard-changes',
      onClickCancel: () => {},
      onClickOk: () => {
        applicationContext.popNavigationItem();
        applicationContext.popNavigationItem();
      },
      titleDialog: 'clinical-notes.discard-changes',
      titleOnCancel: 'patient-evolution.cancel',
      titleOnOk: 'clinical-notes.discard-submit'
    });
  }

  @OnUnmount(ScoreFlexCreateAliases.SCORE_FLEX_ADD_LAYOUT)
  handleUnmount(): void {
    ScoreListContext.clean();
    ScoreListContext.currentTab = ScoreType.SCORE_FLEX;
  }

}